import {
  Directive,
  Input
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  Validator
} from '@angular/forms';

import { BigDecimalService } from '../../core/services/big-decimal.service';
import { SessionService } from '../../sessions/session.service';

@Directive({
  selector : '[worNumberValidator]',
  providers: [
    {
      multi      : true,
      provide    : NG_VALIDATORS,
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      useExisting: NumberValidator
    }
  ]
})
export class NumberValidator implements Validator {
  private _defaultValidation = new RegExp(this.sessionService.currency().validation);

  @Input() max   ?: number;
  @Input() min    : number;
  @Input() round  : number;

  @Input('worNumberValidator') value: string;

  constructor (
    private bigDecimalService : BigDecimalService,
    private sessionService    : SessionService
  ) {}

  validate ( control: AbstractControl ) : { [ key: string ] : any } {
    /**
     * Allow empty values, initial decimal for numbers less than
     * one, and allow initial dash for negative numbers;
     */
    if ( !control.value
      || ( this.min < 1 && control.value === '.' )
      || ( this.min < 0 && control.value === '-' )
    ) {
      return null;
    }

    if ( this._defaultValidation.test(control.value) ) {
      const max   = this.bigDecimalService.get(this.max);
      const min   = this.bigDecimalService.get(this.min);
      const value = this.bigDecimalService.get(control.value);

      if (value.isLessThan(min)) {
        return { min: true };
      }

      if ( this.max && this.max !== 0 && value.isGreaterThan(max) ) {
        return { max: true };
      }

      return null;
    }

    return { number: true };
  }
}